module.exports = __webpack_public_path__ + "img/symbol_5.6d4f81b9.png";